export default {
	cssAssets: {
      type: 'array',
      default: [],
    },
    jsAssets: {
      type: 'array',
      default: [],
    },
    currentPackage: {
      type: 'string',
      default: 'none'
    }
};
